import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'
import { Button, Box } from '@chatterbug/aaron'
import PageWrapupActions from 'src/ui/PageWrapup/subcomponents/PageWrapupActions/PageWrapupActions'

import ActivityWrapupSkeleton from './ActivityWrapupSkeleton'
import WrapupGoalCelebration from './subcomponents/WrapupGoalCelebration/WrapupGoalCelebration'
import WrapupCardStudyGoals from './subcomponents/WrapupCardStudyGoals/WrapupCardStudyGoals'

const ActivityWrapupGoalCelebration = ({
  activityType,
  weeklyGoals,
  goalReached,
  onContinue,
}) => {
  return (
    <Box as="section" data-activity-goal-celebration={goalReached}>
      <ActivityWrapupSkeleton
        activityType={activityType}
        headingSection={<WrapupGoalCelebration goalReached={goalReached} />}
        goalsSection={
          <WrapupCardStudyGoals
            animateCompletion
            weeklyGoals={weeklyGoals}
          />
        }
        actionsSection={
          <PageWrapupActions
            primaryActionSection={
              <Button type="primaryAdvanced" onClick={onContinue}>
                {t('Continue')}
              </Button>
            }
          />
        }
      />
    </Box>
  )
}

ActivityWrapupGoalCelebration.propTypes = {
  activityType: PropTypes.string.isRequired,
  weeklyGoals: PropTypes.object,
  goalReached: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
}

export default ActivityWrapupGoalCelebration
